module.exports = __webpack_public_path__ + "img/album18_23.3ae00d12.jpg";